import { isNullIndex } from "./planUtils";
import { isWithId, WithId } from "../data/lookups";
import { AvailabilityDto, ShopDto, ShoppingListDto } from "../api";

export type WithDeletedAndEdited = {
  deleted?: boolean;
  edited?: boolean;
};

export type AvailabilityWithEditedFlags = AvailabilityDto &
  WithDeletedAndEdited;

export type ShopWithEditedFlags = ShopDto & WithDeletedAndEdited;

export type ShoppingListWithEditedFlags = ShoppingListDto &
  WithDeletedAndEdited;

export function isNew(withId: WithId | undefined) {
  if (withId === undefined) {
    return false;
  }
  return isNullIndex(withId.id);
}

export function isEdited(withEdited: WithDeletedAndEdited | undefined) {
  return withEdited?.edited && (!isWithId(withEdited) || !isNew(withEdited));
}

export function isDeleted(withDeleted: WithDeletedAndEdited | undefined) {
  return (
    withDeleted?.deleted && (!isWithId(withDeleted) || !isNew(withDeleted))
  );
}
